export const INSTANCE_CONFIG_KEY = 'instance-config';
export const COUNTRIES_KEY = 'countries';
export const USER_KEY = 'user';
export const ACTIVE_CASES_KEY = 'active-cases';
export const COMPANIES_KEY = 'companies';
export const CURRENCIES_KEY = 'currencies';
export const AGREEMENTS_KEY = 'agreements';
export const PROFILE_PICTURE_KEY = 'profile-picture';
export const CASE_DETAILS_KEY = 'case-details';
export const CASE_STAGE_KEY = 'case-stage';
export const CASE_QUESTIONNAIRES_KEY = 'case-questionnaires';
export const QUESTIONNAIRE_DETAILS_KEY = 'questionnaire-details';
export const QUESTIONNAIRE_DETAILS_TREE_KEY = 'questionnaire-details-tree';
export const QUESTIONNAIRE_ANSWERS_KEY = 'questionnaire-answers';
export const CASE_SUBPROJECTS_KEY = 'case-subprojects';
export const GOVERNMENT_CASE_NUMBERS_KEY = 'government-case-numbers';
export const CASE_HIGH_LEVEL_STATUS_KEY = 'case-high-level-status';
export const BENEFICIARY_RESOURCE_DOCUMENT_KEY = 'beneficiary-resource-document';
export const ACTIVE_AGREEMENTS_KEY = 'active-agreements';
export const AGREEMENT_KEY = 'agreement';
export const AGREEMENTS_TO_ACCEPT_KEY = 'agreements-to-accept';
export const USER_CONTACTS_KEY = 'user-contacts';
export const USER_PROFILES_IMAGE_KEY = 'user-profiles-image';
export const BENEFICIARY_KEY = 'beneficiary';
export const BENEFICIARY_DEPENDENTS_KEY = 'beneficiary-dependents';
export const IMMIGRATION_DOC_DETAILS = 'immigration-doc-details';
export const IMMIGRATION_SNAPSHOTS = 'immigration-snapshots';
export const CASE_LIST_KEY = 'case-list';
export const ALL_ACTIVE_CASES_KEY = 'all-active-cases';
export const SECURE_MESSAGES_KEY = 'secure_message';
export const DOCUMENTS_SEARCH_KEY = 'documents-search';
export const DROPDOWN_ITEMS_KEY = 'dropdown-items';
export const REFERENCE_DATA_KEY = 'referencedata';
export const STATES_KEY = 'states';
export const IMMIGRATION_STATUS_KEY = 'immigration-status-info';
export const IMMIGRATION_STATUS_LIST_KEY = 'immigration-status-list';
export const CLASSIFICATION_COUNTRY_KEY = 'classification-country';
export const PRIORITY_DATES_KEY = 'priority-dates';
export const PASSPORT_DETAILS_KEY = 'passport-details';
export const IMMIGRATION_DOC_DETAILS_KEY = 'immigration-doc-details';
export const IMMIGRATION_DOC_DETAILS_ID_KEY = 'immigration-doc-details-id';
export const PROFILE_IMMIGRATION_DOC_DETAILS_KEY = 'profile-immigration-doc-details';
export const MANAGER_CONTRACTS_KEY = 'manager-contacts';
export const COMPANY_ENTITIES_KEY = 'entities';
export const COMPANY_BUSINESS_UNITS_KEY = 'business-units';
export const WORK_LOCATIONS_KEY = 'worklocations';
export const CASE_CHECKLIST_KEY = 'checklist';
export const EDUCATION_HISTORIES = 'education-histories';
export const DOCUMENT_TYPES_KEY = 'document-types';
export const DOCUMENT_KEY = 'document';
export const IMMIGRATION_DOC_DRAFT_KEY = 'immigration-doc-draft';
export const PASSPORTS_KEY = 'passports';
export const BENEFICIARY_PASSPORTS_KEY = 'beneficiary-passports';
export const CASE_PASSPORTS_KEY = 'case-passports';
export const ADDITIONAL_DOCUMENTS_KEY = 'additional-documents';
export const AUTOMATION_PENDING_CONFIRMATION = 'automation-pending-confirmation';
export const BENE_MEMBERS_KEY = 'bene-members';
export const BENE_REMOTE_ID_KEY = 'bene-remote-id';
export const DEVICE_REGISTRATION_DATE = 'device-registration-date';
export const NEW_RECOVERY_KEY = 'new-recovery-key';
export const IMMIGRATION_PROVIDERS_KEY = 'immigration-providers';
export const I94_BANNER_STATUS_KEY = 'i94-banner-status';
export const HAS_ACTIVE_US_CASE_KEY = 'has-active-us-case';
export const CASE_DOCUMENTS_KEY = 'case-documents';
